<template>
  <template v-if="editableMode">
    <tr class="font-bold">
      <th class="align-middle px-2 text-center border-r border-t-8" rowspan="3" />
      <th class="px-6 py-2 w-4/12 text-left border-r border-t-8">
        Nama Kepala Keluarga
      </th>
      <th class="px-6 py-2 w-3/12 text-left border-r border-t-8">
        Nomor KK
      </th>
      <th class="px-6 py-2 w-3/12 text-left border-r border-t-8">
        QR Code
      </th>
      <th
        v-if="!disabled"
        class="py-6 border-l border-t-8"
        rowspan="2">
        <div class="flex items-center px-6 py-4">
          <button title="Save Changes" @click="store">
            <Icon icon="ic:baseline-save" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Cancel Edit" @click="cancel">
            <Icon icon="ic:baseline-restart-alt" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </th>
    </tr>
    <tr>
      <td class="border-r border-t">
        <text-input
          v-model="family.head_name"
          class="form-error px-3"
          :error="errors.head_name" />
      </td>
      <td class="border-r border-t">
        <text-input
          v-model="family.head_kk_num"
          class="form-error px-3"
          :error="errors.head_kk_num" />
      </td>
      <td class="text-left border-r border-t">
        <text-input
          v-model="family.qr_code"
          class="form-error px-3"
          :error="errors.qr_code" />
      </td>
    </tr>
    <tr>
      <td class="border-r border-t pb-4" colspan="3">
        <label class="px-3 text-sm font-bold text-gray-600">Alamat Lokasi</label>
        <text-input
          v-model="family.location_address"
          class="form-error px-3 mt-1"
          :error="errors.location_address" />
      </td>
    </tr>
  </template>
  <template v-else>
    <tr class="font-bold">
      <th class="align-middle px-2 text-center border-r border-t-8" rowspan="3">
        {{ rowIndex }}.
      </th>
      <th class="px-6 py-2 w-4/12 text-left border-r border-t-8">
        Nama Kepala Keluarga
      </th>
      <th class="px-6 py-2 w-3/12 text-left border-r border-t-8">
        Nomor KK
      </th>
      <th class="px-6 py-2 w-3/12 text-left border-r border-t-8">
        QR Code
      </th>
      <th
        v-if="!disabled"
        class="py-2 border-l border-t-8"
        rowspan="2">
        <div class="flex items-center px-6 py-4">
          <button title="Edit Family" @click="edit">
            <Icon icon="ic:baseline-edit-note" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Delete Family" @click="destroy">
            <Icon icon="ic:baseline-delete" class="block w-6 h-6 fill-gray-400" />
          </button>
          <Link title="View Members" :href="`/assessments/${familyDetail.assessment_m_id}/families/${familyDetail.id}`">
            <Icon icon="mdi:eye" class="block w-6 h-6 fill-gray-400" />
          </Link>
        </div>
      </th>
    </tr>
    <tr>
      <td class="border-r border-t">
        <div class="flex items-center px-6 py-4">
          {{ familyDetail.head_name }}
        </div>
      </td>
      <td class="border-r border-t">
        <div class="flex items-center px-6 focus:text-indigo-500">
          {{ familyDetail.head_kk_num || '-' }}
        </div>
      </td>
      <td class="text-left border-r border-t">
        <div class="px-6 py-4 text-left">
          {{ familyDetail.qr_code || '-' }}
        </div>
      </td>
    </tr>
    <tr>
      <td class="border-r border-t pb-4" colspan="3">
        <div class="px-6 py-2 text-sm text-gray-500">
          <span class="font-bold">Alamat:</span> {{ familyDetail.location_address }}
          <span v-if="familyDetail.family_member_count" class="ml-4 font-bold">Anggota:</span>
          <span v-if="familyDetail.family_member_count">{{ familyDetail.family_member_count }}</span>
        </div>
      </td>
    </tr>
  </template>
</template>

<script lang="js">
import { Link } from '@inertiajs/vue3'
import { Icon } from '@iconify/vue'
import { ref } from 'vue'
import TextInput from '@/Shared/TextInput'
import clone from 'lodash/clone'

export default {
    components: {
        Icon,
        TextInput,
        Link,
    },
    props: {
        familyDetail: Object,
        errors: Object,
        editableMode: {
            type: Boolean,
            default: false,
        },
        rowIndex: {
            type: Number,
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['destroy:detail', 'cancel', 'save', 'edit:detail'],
    setup (props) {
        const family = ref(props.familyDetail)
        const oriData = ref(typeof familyDetail)

        return {
            family,
            oriData,
        }
    },
    methods: {
        edit () {
            this.oriData = clone(this.familyDetail)
            this.$emit('edit:detail', this.family)
        },
        cancel () {
            this.family = clone(this.oriData)
            this.$emit('cancel')
        },
        store () {
            this.$emit('save', this.family)
        },
        destroy () {
            if (confirm('Are you sure you want to delete this family?')) {
                this.$emit('destroy:detail', this.familyDetail.id)
            }
        },
    },
}
</script>
